import React from 'react';

import { Box } from '@primer/components'

import Advice from './Advice'


export default function AdviceList(props) {
  return (
    <Box className="container-lg mt-6 pb-md-6" id={props.id}>
      <div className="pt-4 pb-0">
        {
          props.messageIds.map((messageId, i) => 
            <Advice
              key={i}
              messageId={messageId}
              defaultOpen={i===0}
              style={i===0 ? {borderTop: 0} : {}}
              showLabels={props.showLabels}
            />
         )
      }
      </div>
    </Box>
  );
}

AdviceList.defaultProps = {
  showLabels: true
}
